import { Modal } from "antd";
import React, { PureComponent } from "react";

class ModalBox extends PureComponent {
  render() {
    const {
      open,
      title,
      onOk,
      onCancel,
      okText,
      cancelText,
      footer,
      destroyOnClose, // still destructured for backward compatibility
      width,
      wrapClassName,
    } = this.props;

    return (
      <div>
        <Modal
          open={open}
          title={title}
          onOk={onOk}
          onCancel={onCancel}
          footer={footer}
          destroyOnHidden={destroyOnClose} // ✅ replaced `destroyOnClose` with `destroyOnHidden`
          width={width}
          wrapClassName={wrapClassName}
          maskClosable={false}
          okText={okText}
          cancelText={cancelText}
        >
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default ModalBox;
